// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1Qvat","header":"ClearentDisclaimer_header__DpI6i","inner":"ClearentDisclaimer_inner__1ujT3"};